var scope_0 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0212f2860e97e9e620c83c20455e1bb7.js').default;

var scope_1 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5773867a9d22729f0af08329f92d84bf.js').default;

var scope_2 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7f4e09a2bf02d4997bc2adc90894dc69.js').default;

var scope_3 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/80c3394517d00be5890e5d2c7f9d5975.js').default;

var scope_4 = require('/opt/render/project/src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4);